/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serviceunavailableerror2Inputs */

const en_serviceunavailableerror2 = /** @type {(inputs: Serviceunavailableerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The service is temporarily unavailable. Please try again later.`)
};

const de_serviceunavailableerror2 = /** @type {(inputs: Serviceunavailableerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify ist gerade nicht erreichbar. Versuch's gleich nochmal.`)
};

/**
* | output |
* | --- |
* | "The service is temporarily unavailable. Please try again later." |
*
* @param {Serviceunavailableerror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const serviceunavailableerror2 = /** @type {((inputs?: Serviceunavailableerror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serviceunavailableerror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_serviceunavailableerror2(inputs)
	return de_serviceunavailableerror2(inputs)
});
export { serviceunavailableerror2 as "serviceUnavailableError" }